import { createAsyncThunk, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit'
import { Auth } from 'aws-amplify';
import { RootState } from '../../store/store';
import { Loading } from '../../App/app';
import { feedback } from '../../components/Feedback/feedback';
import i18n from '../../i18n/i18n';

export interface State {
  loading: Loading,
  currentRequestId: string,
  error: SerializedError | null,
  exceeded: boolean,
}


const initialState: State = {
  loading: 'idle',
  currentRequestId: '',
  error: null,
  exceeded: false,
}

export const reset = createAsyncThunk(
  'forgotPassword/reset',
  async ( username: string, thunkAPI ) => {
    const state = thunkAPI.getState() as RootState;
    const { currentRequestId, loading } = state.pages.forgotPassword;

    if ( loading !== 'pending' || thunkAPI.requestId !== currentRequestId ) return;

    const clientMetaData = {
      username: username,
      language: state.app.language,
      redirectURI: state.app.searchParameters.redirect_uri
    }

    return Auth.forgotPassword( username, clientMetaData ).then( codeDeliveryDetails => {
      // CodeDeliveryDetails: {
      //   "AttributeName": "email",
      //   "DeliveryMedium": "EMAIL",
      //   "Destination": "u***@h***"
      // }
      return true;
    }).catch( error => {
      if (error.message.includes("Attempt limit exceeded"))
      {
        thunkAPI.dispatch(exceededUpdated(true));
      }
      return false;
    })
  }
)

export const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  initialState,
  reducers: {
    exceededUpdated: (state, action: PayloadAction<boolean>) => {
      state.exceeded = action.payload;
    }
  },
  extraReducers: ( builder ) => {
      builder.addCase( reset.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending'
          state.currentRequestId = action.meta.requestId
        }
      })
      .addCase( reset.fulfilled, (state, action) => {
        const { requestId } = action.meta
        if ( state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle'
          // state.entities.push(action.payload)
          state.currentRequestId = ''
        }
      })
      .addCase( reset.rejected, ( state, action, ) => {
        const { requestId } = action.meta
        if (
          state.loading === 'pending' &&
          state.currentRequestId === requestId
        ) {
          state.loading = 'idle'
          state.error = action.error
          state.currentRequestId = ''
        }
      })

  },
})

export const { exceededUpdated } = forgotPasswordSlice.actions

export default forgotPasswordSlice.reducer
